exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".buddySelect-36313{width:292px}.avatar-a1c0d{margin-left:10px}.label-07880{font-weight:600}", ""]);

// Exports
exports.locals = {
	"buddySelect": "buddySelect-36313",
	"avatar": "avatar-a1c0d",
	"label": "label-07880"
};